import { type PageContext } from '@blaze-shared/projects-domain';

/** Where a navigate node is sending the user, and what it carries along. */
export interface PageNavigationRequest {
  openInNewTab?: boolean;
  pageContext?: PageContext;
  targetPageId: string;
  targetProjectId?: string;
  /** Omitted names keep the target page's own defaults. */
  urlQueryParams?: Record<string, string>;
}

/**
 * Takes the user to a page of the running app.
 *
 * The engine owns the router, the page registry and what "the same project" means, so a navigate
 * node asks for the page through this port instead of driving navigation itself.
 */
export abstract class EnginePageNavigation {
  /**
   * Navigates to `targetPageId`, in the current project unless a `targetProjectId` says otherwise.
   * @throws when the page does not exist.
   */
  abstract navigateToPage(request: PageNavigationRequest): void;
}
